export default "__VITE_ASSET__Vm8ccjlj__"